import type { FC } from 'react';

import { Container, Progress } from './styled';

interface IProgressBar {
    progress: number;
}

export const ProgressBar: FC<IProgressBar> = ({ progress }) => (
    <Container>
        <Progress style={{ width: `${progress}%` }} />
    </Container>
);
